import {
  Box,
  Button,
  styled,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { motion, transform } from "framer-motion";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteRounded from "@mui/icons-material/FavoriteRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { addItem } from "../redux/Cart/CartReducer";
import {
  toggleItemToWishlist,
  wishlistProductSelector,
} from "../redux/Wishlist/WishlistReducer";
import ShowImageModal from "./ShowImageModal";
import { Link } from "react-router-dom";
const SubTitle = styled((props) => (
  <Typography {...props} variant="body2">
    {props.children}
  </Typography>
))(({ theme }) => ({
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 600,
  letterSpacing: { sx: 1, sm: 1, md: 2, lg: 2 },
  color: "#4D5959",
  textTransform: "uppercase",
  textAlign: "center",
  transition: "0.5s",
  cursor: "pointer",
  "&:hover": {
    color: "#b59677",
  },
}));
const Details = styled((props) => (
  <Typography {...props} variant="body2">
    {props.children}
  </Typography>
))(({ theme }) => ({
  fontFamily: "lato, sans-serif",
  color: "#999999",
  [theme.breakpoints.up("xs")]: {
    display: "none",
  },
  [theme.breakpoints.up("md")]: {
    display: "block",
  },
}));

const StyledButton = styled((props) => (
  <Button {...props}>{props.children}</Button>
))(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(6)}`,
  margin: `${theme.spacing(1)} 0`,
  borderRadius: 0,
}));

const Product = ({
  productDisplayprop,
  id,
  img1,
  img2,
  title,
  oldPrice,
  newPrice,
  colors,
  link,
  sale,
  category,
  details,
}) => {
  const [hover, setHover] = useState(false);
  const isWishlist = useSelector((state) => wishlistProductSelector(state, id));
  console.log("isWishlist", isWishlist);
  const item = {
    id,
    img: img1,
    category: "category",
    title: title,
    price: newPrice,
  };
  const [productDisplay, setProductDisplay] = useState(3);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const isLess750 = useMediaQuery("(max-width:750px)");
  useEffect(() => {
    setProductDisplay(productDisplayprop);
  }, [productDisplayprop]);
  return (
    <>
      {productDisplay === 1 ? (
        <Box
          className="product_wrapper"
          sx={{
            height: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            border: "1px solid #EEEEEE",
            p: 2,
            margin: 0,
            gap: 3.5,
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Box
            sx={{
              overflow: "hidden",
              position: "relative",
              flexBasis: isLess750 ? "140px" : "180px",
              height: "auto",
              flexGrow: 0,
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                padding: "7px",
                display: "inline-block",
                flexDirection: "column",
                background: "var(--gray-100)",
                borderRadius: "12%",
                zIndex: 20,
                position: "absolute",
                width: "auto",
                top: "1%",
                left: "99%",
                transform: "translate(-100%,0)",
                transition: "0.8s",
                opacity: { xs: 1, lg: 0 },
                ...(hover && { opacity: 0.8 }),
              }}
            >
              {!isWishlist ? (
                <FavoriteBorderIcon
                  onClick={() => {
                    dispatch(
                      toggleItemToWishlist({
                        img: img1,
                        title,
                        id: id,
                        price: newPrice,
                      })
                    );
                  }}
                  sx={{
                    display: "block",
                    mb: 1,
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    "&:hover": {
                      path: { stroke: "gray", strokeWidth: "1px" },
                    },
                  }}
                />
              ) : (
                <FavoriteRounded
                  htmlColor="red"
                  onClick={() => {
                    dispatch(
                      toggleItemToWishlist({
                        img: img1,
                        title,
                        id: id,
                        price: newPrice,
                      })
                    );
                  }}
                  sx={{
                    display: "block",
                    mb: 1,
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    "&:hover": {
                      path: { stroke: "gray" },
                    },
                  }}
                />
              )}
            </Box>
            <div
              style={{
                height: "100%",
                width: "100%",
                position: "absolute",
                zIndex: 2,
                top: 0,
                left: 0,
                transition: "0.4s",
                ...(hover && { opacity: 0 }),
              }}
            >
              <img
                width="100%"
                style={{
                  height: "100%",
                  overflow: "hidden",
                  objectFit: "contain",
                }}
                src={img1}
                alt={title}
              />
            </div>

            <div
              style={{
                height: "100%",
                overflow: "hidden",
                width: "100%",
                overflow: "hidden",
              }}
            >
              <img
                style={{
                  height: "100%",
                  overflow: "hidden",
                  ...(hover && {
                    transform: "scale(1.2)",
                    transitionDelay: "0.4s",
                    transitionTimingFunction: "ease-out",
                    transitionDuration: "0.8s",
                    objectFit: "contain",
                  }),
                }}
                width="100%"
                src={img2}
                alt={title}
              />
            </div>
          </Box>
          <Box
            className="content"
            sx={{
              display: "flex",
              flexDirection: isLess750 ? "column" : "row",
              gap: 1.5,
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
                margin: "auto 0",
                gap: 1.5,
                flexGrow: 1,
              }}
            >
              <SubTitle sx={{ textAlign: "left", fontSize: "15px" }}>
                {title}
              </SubTitle>
              <Details>{details}</Details>
              <Box
                className="prices"
                sx={{ display: "flex", justifyContent: "left", gap: 1 }}
              >
                {oldPrice && (
                  <Typography
                    variant="text"
                    sx={{ textDecoration: "line-through", color: "#4D5959" }}
                  >
                    {Intl.NumberFormat("en-EG", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 2,
                    }).format(oldPrice)}
                  </Typography>
                )}
                <Typography
                  variant="h6"
                  fontWeight={"bold"}
                  sx={{ ...(oldPrice && { color: "red" }) }}
                >
                  {Intl.NumberFormat("en-EG", {
                    style: "currency",
                    currency: "EUR",
                    maximumFractionDigits: 2,
                  }).format(newPrice)}
                </Typography>
              </Box>
              {colors.length > 0 && (
                <Box
                  className="colors"
                  sx={{ display: "flex", flexDirection: "row", gap: "4px" }}
                >
                  {colors.map((color) => (
                    <Tooltip title={color} arrow>
                      <Box
                        key={color}
                        sx={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          border: "1px solid #DDDDDD",
                          background: "white",
                          position: "relative",
                          "&:hover": { background: "black" },
                        }}
                      >
                        <Box
                          style={{
                            width: "15px",
                            height: "15px",
                            borderRadius: "50%",
                            background: color,
                            zIndex: 2,
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                          }}
                        ></Box>
                      </Box>
                    </Tooltip>
                  ))}
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "right",
                flexBasis: "auto",
                flexShrink: 0,
                flexGrow: 0,
              }}
            >
              <StyledButton color="primary" variant="outlined">
                Quick view
              </StyledButton>
              <StyledButton
                color="primary"
                sx={{ color: "white" }}
                variant="contained"
              >
                Quick Shop
              </StyledButton>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          className="product_wrapper"
          sx={{
            height: "100%",
            // width: {
            //   // lg: `calc((100% / ${productDisplay}) - 16px + (16px / ${productDisplay}))`,
            //   // md: "calc((100% / 3) - 16px + (16px / 3))",
            //   // sm: "calc((100% / 2) - 16px + (16px / 2))",
            //   // xs: "calc((100% / 2) - 16px + (16px / 2))",
            // },
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            py: 1,
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Box
            sx={{ overflow: "hidden", position: "relative", height: "300px" }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 2,
                top: 0,
                left: 0,
                transition: "0.4s",
                ...(hover && { opacity: 0 }),
              }}
            >
              <Link to={`/collections/${category}/products/${id}`}>
                <img
                  width="100%"
                  style={{ height: "100%", objectFit: "contain" }}
                  src={img1}
                  alt={title}
                />
              </Link>
            </div>

            <div style={{ height: "100%", overflow: "hidden" }}>
              <div
                style={{
                  padding: 7,
                  display: "inline-block",
                  flexDirection: "column",
                  background: "var(--gray-100)",
                  borderRadius: "12%",
                  zIndex: 2,
                  position: "absolute",
                  width: "auto",
                  top: "1%",
                  left: "99%",
                  transform: "translate(-100%,0)",
                  transition: "0.8s",
                  opacity: 0,
                  ...(hover && { opacity: 0.8 }),
                }}
              >
                {!isWishlist ? (
                  <FavoriteBorderIcon
                    onClick={() => {
                      dispatch(
                        toggleItemToWishlist({
                          img: img1,
                          title,
                          id: id,
                          price: newPrice,
                        })
                      );
                    }}
                    sx={{
                      display: "block",
                      mb: 1,
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                      "&:hover": {
                        path: { stroke: "gray", strokeWidth: "1px" },
                      },
                    }}
                  />
                ) : (
                  <FavoriteRounded
                    htmlColor="red"
                    onClick={() => {
                      dispatch(
                        toggleItemToWishlist({
                          img: img1,
                          title,
                          id: id,
                          price: newPrice,
                        })
                      );
                    }}
                    sx={{
                      display: "block",
                      mb: 1,
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                      "&:hover": {
                        path: { stroke: "gray" },
                      },
                    }}
                  />
                )}
                <VisibilityIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(true);
                  }}
                  fontSize="small"
                  sx={{
                    display: "block",
                    stroke: "white",
                    mt: 1,
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    "&:hover": {
                      path: { stroke: "gray" },
                    },
                  }}
                />
              </div>
              <button
                style={{
                  zIndex: 2,
                  cursor: "pointer",
                  border: "none",
                  background: "#b59677",
                  color: "white",
                  width: "100%",
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  height: "15%",
                  transition: "all 0.8s",
                  fontSize: "16px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  ...(hover && { transform: "translate(0,-100%)" }),
                }}
                onClick={() => dispatch(addItem({ ...item, count: 1 }))}
              >
                Add To Cart
              </button>
              <img
                style={{
                  height: "100%",
                  objectFit: "contain",
                  ...(hover && {
                    transform: "scale(1.2)",
                    transitionDelay: "0.4s",
                    transitionTimingFunction: "ease-out",
                    transitionDuration: "0.8s",
                    objectFit: "contain",
                  }),
                }}
                width="100%"
                src={img2}
                alt={title}
              />
            </div>
          </Box>
          <Link
            to={`/collections/${category}/products/${id}`}
            style={{ textDecoration: "none" }}
          >
            <SubTitle
              className={"line-clamp-2"}
              sx={{
                textAlign: "center",
                height: "40px",
                fontSize: "15px",
                marginTop: "5px",
              }}
            >
              {title}
            </SubTitle>
          </Link>
          <Box
            className="prices"
            sx={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            {oldPrice && (
              <Typography
                variant="text"
                sx={{ textDecoration: "line-through" }}
              >
                {Intl.NumberFormat("en-EG", {
                  style: "currency",
                  currency: "EUR",
                  maximumFractionDigits: 2,
                }).format(oldPrice)}
              </Typography>
            )}
            <Typography
              fontWeight={"bold"}
              variant="h6"
              sx={{ ...(oldPrice && { color: "red" }) }}
            >
              {Intl.NumberFormat("en-EG", {
                style: "currency",
                currency: "EUR",
                maximumFractionDigits: 2,
              }).format(newPrice)}
            </Typography>
          </Box>
          {colors.length > 0 && (
            <Box
              className="colors"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "4px",
                marginX: "auto",
              }}
            >
              {colors.map((color) => (
                <Tooltip title={color} arrow>
                  <Box
                    key={color}
                    sx={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      background: "gray",
                      position: "relative",
                      "&:hover": { background: "black" },
                    }}
                  >
                    <Box
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        background: color,
                        zIndex: 2,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                      }}
                    ></Box>
                  </Box>
                </Tooltip>
              ))}
            </Box>
          )}
        </Box>
      )}
      {isOpen && (
        <ShowImageModal setIsOpen={setIsOpen} src={img1} title={title} />
      )}
    </>
  );
};

export default Product;
